import { Component, transition } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SessionProvider } from '../../../providers/SessionProvider';
import { ServiceProvider } from '../../../providers/ServiceProvider';
import { CompanyDetailsPage } from '../CompanyDetails/CompanyDetails';
import { ValueTransformer } from '@angular/compiler/src/util';

/*
  Generated class for the CompanySearch page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-CompanySearch',
    templateUrl: 'CompanySearch.html'
})
export class CompanySearchPage {
    ShowingSearch: boolean = true;
    isCompany: boolean = true;
    Companies: any = [];
    AllCompanies: any = [];
    Regions: any = [];
    MD66: any = [];
    a_Md66: any = -1;
    a_Region: any = -1;
    a_Name: string = '';
    a_Kons: boolean = null;
    a_KonsP: boolean = null;

    a_Gondole: boolean = null;
    a_GondoleP: boolean = null;

    a_Ehya: boolean = null;
    a_EhyaP: boolean = null;

    a_Zob: boolean = null;
    a_ZobP: boolean = null;

    a_Navard: boolean = null;
    a_NavardP: boolean = null;

    constructor(public navCtrl: NavController, public navParams: NavParams, public sessionProvider: SessionProvider, public serviceProvider: ServiceProvider) {
        if (this.navParams.get('isCompany') == false) {
            this.isCompany = false;
            this.ShowingSearch = true;
        }
        this.loadCompanys();
    }
    customActionSheetOptions: any = {
        header: 'Colors',
        subHeader: 'Select your favorite color',
        buttons: []
    };
    loadCompanys() {
        this.serviceProvider.Get("/Metadata/0/61", true).then((result) => {
            let regions: any = result;
            this.Regions.push({
                Title: "همه استانها",
                Id: -1
            });
            regions.forEach((region, index) => {
                this.Regions.push(region);
            });
        }).catch((reson) => {
            console.log(reson);
        });


        if (this.isCompany) {
            this.AllCompanies.splice(0, this.AllCompanies.length);
            this.serviceProvider.Get("/IspaCompanyList?tMDId61_Region=null&tDataComboId1=null&cuName=null&Id=", true).then((result) => {
                let companies: any = result;
                companies.forEach((company, index) => {
                    this.AllCompanies.push(company);
                });
                console.log(this.AllCompanies);
                this.RefreshCompanyList();
            });
        }
        else {
            this.GetSupliers();
            this.serviceProvider.Get("/Metadata/0/66/2435", true).then((result) => {
                let md66: any = result;
                this.MD66.push({
                    Title: "همه گروهبندی ها",
                    Id: null
                });
                md66.forEach((region, index) => {
                    this.MD66.push(region);
                });
            });
        }
    }

    GetSupliers() {
        let reg = this.a_Region == -1 ? "" : this.a_Region + "";
        let md66 = this.a_Md66 == -1 ? "" : this.a_Md66 + "";
        this.AllCompanies.splice(0, this.AllCompanies.length);
        let url = "/IspaSupplierList?tMDId61_Region=" + reg + "&tMdId66_2435=" + md66 + "&tMdId66_2436=&tMdId66_2437=&cuName=";
        this.serviceProvider.Get(url, true).then((result) => {
            let companies: any = result;
            companies.forEach((company, index) => {
                this.AllCompanies.push(company);
            });
            this.RefreshCompanyList();
        });
    }

    ShowCompanyDetails(company) {
        console.log(company);
        this.navCtrl.push(CompanyDetailsPage, { companyData: company });
    }
    ShowSearch() {
        this.ShowingSearch = !this.ShowingSearch;
    }

    Kons() {
        if (this.a_Kons == null) {
            this.a_Kons = true;
        }
        else {
            this.a_Kons = null;
        }
        this.RefreshCompanyList();
    }
    KonsP() {
        if (this.a_KonsP == null) {
            this.a_KonsP = true;
        }
        else {
            this.a_KonsP = null;
        }
        this.RefreshCompanyList();
    }
    Ehya() {
        if (this.a_Ehya == null) {
            this.a_Ehya = true;
        }
        else {
            this.a_Ehya = null;
        }
        this.RefreshCompanyList();
    }
    EhyaP() {
        if (this.a_EhyaP == null) {
            this.a_EhyaP = true;
        }
        else {
            this.a_EhyaP = null;
        }
        this.RefreshCompanyList();
    }
    Zob() {
        if (this.a_Zob == null) {
            this.a_Zob = true;
        }
        else {
            this.a_Zob = null;
        }
        this.RefreshCompanyList();
    }
    ZobP() {
        if (this.a_ZobP == null) {
            this.a_ZobP = true;
        }
        else {
            this.a_ZobP = null;
        }
        this.RefreshCompanyList();
    }
    Gondole() {
        if (this.a_Gondole == null) {
            this.a_Gondole = true;
        }
        else {
            this.a_Gondole = null;
        }
        this.RefreshCompanyList();
    }
    GondoleP() {
        if (this.a_GondoleP == null) {
            this.a_GondoleP = true;
        }
        else {
            this.a_GondoleP = null;
        }
        this.RefreshCompanyList();
    }
    Navard() {
        if (this.a_Navard == null) {
            this.a_Navard = true;
        }
        else {
            this.a_Navard = null;
        }
        this.RefreshCompanyList();
    }
    NavardP() {
        if (this.a_NavardP == null) {
            this.a_NavardP = true;
        }
        else {
            this.a_NavardP = null;
        }
        this.RefreshCompanyList();
    }

    RefreshCompanyList() {
        this.Companies.splice(0, this.Companies.length);
        this.AllCompanies.forEach((value, index) => {
            if (this.a_Name != '') {
                if (value.cuName.indexOf(this.a_Name) < 0) {
                    return;
                }
            }
            if (this.a_Region != -1) {
                if (value.cRegionId != this.a_Region) {
                    return;
                }
            }
            if (this.a_Kons == true) {
                if (value.Kons == null) {
                    return;
                }
            }
            if (this.a_KonsP == true) {
                if (value.KonsP == null) {
                    return;
                }
            }
            if (this.a_Gondole == true) {
                if (value.Gondole == null) {
                    return;
                }
            }
            if (this.a_GondoleP == true) {
                if (value.GondoleP == null) {
                    return;
                }
            }
            if (this.a_Ehya == true) {
                if (value.Ehya == null) {
                    return;
                }
            }
            if (this.a_EhyaP == true) {
                if (value.EhyaP == null) {
                    return;
                }
            }
            if (this.a_Zob == true) {
                if (value.Zob == null) {
                    return;
                }
            }
            if (this.a_ZobP == true) {
                if (value.ZobP == null) {
                    return;
                }
            }
            if (this.a_Navard == true) {
                if (value.Navard == null) {
                    return;
                }
            }
            if (this.a_NavardP == true) {
                if (value.NavardP == null) {
                    return;
                }
            }
            this.Companies.push(value);
        });
        console.log(this.Companies);
    }

    getCapacity(value) {
        if (value > 999) {
            return (value / 1000);//+ "" + (value % 1000);
        }
        else {
            return value;
        }
    }
    ShowMore(company) {
        if (company.ShowingMore == true) {
            company.ShowingMore = false;
        }
        else {
            company.ShowingMore = true;
            if (company.companyCdatas == null) {
                this.serviceProvider.Get("/VirtualForms/Customer/" + company.tCustomerId, true).then((result) => {
                    let odatas: any = result;
                    if (odatas.length > 0) {
                        if (odatas[0].tCustomerODataId != null) {
                            company.loadingcData = true;
                            this.serviceProvider.Get("/ISPA_VFToken?codId=" + odatas[0].tCustomerODataId, true).then((cdata) => {
                                let companyCdatas: any = cdata;
                                company.companyCdatas = companyCdatas[0];
                                company.loadingcData = false;
                            });
                        }
                    }
                });
            }
        }

        
    }
}



// WEBPACK FOOTER //
// ./src/pages/atlas/CompanySearch/CompanySearch.ts